module.exports = __webpack_public_path__ + "static/media/California_manufacturing_business_guide_wbn_b2b_export_suppliers.d2df6388.svg";